// extracted by mini-css-extract-plugin
export default {"advertDetailInfoService__value":"c-h_gE","advertDetailInfoService__price":"c-h_gF"};